<div mat-dialog-title>Too Few Packages</div>
<div mat-dialog-content>
    There are too few items in your collection. Collections need to have at least 2 packages to become public.
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Ok</button>
</div>
